import { Injectable, inject } from '@angular/core';
import { AuthService } from './auth/auth.service';

export type EmailDeliveryMode = 'inApp' | 'outsourceEmail';

/** Per-user preference for how claim images are emailed, edited from the Edit User tab. */
@Injectable({
  providedIn: 'root',
})
export class EmailDeliveryPreferenceService {
  private authService = inject(AuthService);
  private static readonly STORAGE_PREFIX = 'emailDeliveryMode';

  getMode(userId?: string | number | null): EmailDeliveryMode {
    try {
      const stored = localStorage.getItem(this.storageKey(userId));
      return stored === 'outsourceEmail' ? 'outsourceEmail' : 'inApp';
    } catch {
      return 'inApp';
    }
  }

  setMode(mode: EmailDeliveryMode, userId?: string | number | null): void {
    try {
      localStorage.setItem(this.storageKey(userId), mode);
    } catch {
      // storage may be unavailable (e.g. private browsing); the caller keeps its in-memory value
    }
  }

  private storageKey(userId?: string | number | null): string {
    const resolvedUserId = userId ?? this.authService.currentUserValue?.userId ?? 'anonymous';
    return `${EmailDeliveryPreferenceService.STORAGE_PREFIX}.${resolvedUserId}`;
  }
}
